<ng-container *transloco="let t">
  <div class="w-100 h-100 row no-gutters d-flex justify-content-center align-items-center">
    <mat-card class="m-3 mat-elevation-z8 col-11 col-md-6 col-lg-4">
      <mat-card-content class="px-3 text-center">
        <img src="assets/img/logo.svg" class="mb-5 w-100" />
        <form [formGroup]="loginForm" id="loginForm">
          <mat-form-field class="w-100">
            <mat-label for="username">{{t('auth.username')}}</mat-label>
            <input matInput type="username" fullWidth formControlName="username" (keyup.enter)="login()" />
          </mat-form-field>
          <mat-form-field class="w-100 mt-3">
            <mat-label for="password">{{t('auth.password')}}</mat-label>
            <input type="password" matInput fullWidth formControlName="password" (keyup.enter)="login()">
          </mat-form-field>
        </form>
      </mat-card-content>
      <mat-card-actions class="d-flex justify-content-center">
        <button mat-raised-button color="primary" type="button" form="loginForm" [disabled]="loginForm.invalid"
          (click)="login()">
          {{t('buttons.login')}}
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</ng-container>
